import { DynamicIconType } from '@allesauto/utils/consts';
import React from 'react';

import DynamicIcon from '../dynamicIcon';

export type BrandItemProps = {
  icon?: DynamicIconType;
  title: string;
  text: string;
  position?: string;
};

const classNames = {
  container: 'mt-65px',
  iconContainer: 'mb-20px lg:mb-35px color-purple80',
  icon: 'text-purple80 monochrome:text-grey90',
  title:
    'text-headline4 font-headline text-purple80 monochrome:text-grey90 lg:mb-20px mb-10px',
  text: 'font-regular text-grey80 text-p1Long lg:mb-80px',
};

const BrandItem = ({ icon, title, text }: BrandItemProps) => {
  return (
    <div className={classNames.container}>
      {icon && (
        <div className={classNames.iconContainer}>
          <DynamicIcon icon={icon} customClassName={classNames.icon} />
        </div>
      )}
      <h3 className={classNames.title}>{title}</h3>
      <div
        className={classNames.text}
        dangerouslySetInnerHTML={{ __html: text }}
      />
    </div>
  );
};

export default BrandItem;
